export default {
  shape: 'Shape | Shapes',
  icons: 'Icons',
  properties: 'Properties',
  color: 'Color',
  fill: 'Fill',
  stroke: 'Stroke',
  strokeWidth: 'Stroke width',
  strokeType: 'Stroke type',
  fontColor: 'Font color',
  fontSize: 'Font size',
  fontBackgroundColor: 'Font background color',
  lineType: 'Line type',
  backgroundColor: 'Background color',
  shapes: {
    rectangle: 'Rectangle',
    roundedRectangle: 'Rounded rectangle',
    square: 'Square',
    rhombus: 'Rhombus',
    circle: 'Circle',
    ellipse: 'Ellipse',
    parallelogram: 'Parallelogram',
    process: 'Process',
    document: 'Document',
    storage: 'Storage',
    curve: 'Curve',
    curveArrow: 'Curve arrow',
    bidirectionalCurve: 'Bidirectional curve',
    line: 'Line',
    arrowLine: 'Arrow line',
    bidirectionalArrowLine: 'Bidirectional arrow line',
    text: 'Text',
    textbox: 'Textbox',
    image: 'Image',
  },
  panzoom: {
    helpText: 'Useful shortcuts:\n'
      + 'Ctrl + mouse wheel - zoom in/out\n'
      + 'Ctrl + Left mouse click + drag - pan the area\n'
      + 'Middle mouse click + drag - pan the area\n'
      + 'Shift + mouse wheel - horizontal scroll\n'
      + 'Alt + mouse wheel - vertical scroll\n',
  },
  errors: {
    pointsRequired: 'The points must be added',
  },
};
